<template>
    <div id="yxmh">
        
        <img :src="urlList[0].src" alt="">
        <img :src="urlList[1].src" alt="">
        <img :src="urlList[2].src" alt="">
        <img :src="urlList[3].src" alt="">
        <img :src="urlList[4].src" alt="">
        <img :src="urlList[5].src" alt="">
    </div>
</template>

<script>
    export default {
        name: "yanxidamiaohui",
        data: function () {
            return {
                pcUrl: [
                    {src: require('../images/pc/miaohui/images/庙会详情(明清宫苑)_01.jpg')},
                    {src: require('../images/pc/miaohui/images/庙会详情(明清宫苑)_02.jpg')},
                    {src: require('../images/pc/miaohui/images/庙会详情(明清宫苑)_03.jpg')},
                    {src: require('../images/pc/miaohui/images/庙会详情(明清宫苑)_04.jpg')},
                    {src: require('../images/pc/miaohui/images/庙会详情(明清宫苑)_05.jpg')},
                    {src: require('../images/pc/miaohui/images/庙会详情(明清宫苑)_06.jpg')}
                ],
                mobileUrl: [
                    {src: require('../images/mobile/miaohui/images/yxmh_01.jpg')},
                    {src: require('../images/mobile/miaohui/images/yxmh_02.jpg')},
                    {src: require('../images/mobile/miaohui/images/yxmh_03.jpg')},
                    {src: require('../images/mobile/miaohui/images/yxmh_04.jpg')},
                    {src: require('../images/mobile/miaohui/images/yxmh_05.jpg')},
                    {src: require('../images/mobile/miaohui/images/yxmh_06.jpg')},
                ],
                urlList: '',
            }
        },
        created: function () {
            if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
                this.urlList = this.mobileUrl;
            } else {
                this.urlList = this.pcUrl;
            }
        }
    }
</script>

<style scoped lang="scss">
    #yxmh {
        img {
            display: block;
            width: 100vw;
        }
    }
</style>